import React from 'react';
import './UnitedPage.css';
import UnitedPlaceholder from './UnitedPlaceholder';

/* Rendered inside ProjectReveal's own scroll surface — it doesn't own a page
   or the window scroll anymore. */
const UnitedPage: React.FC = () => {
  return (
    <div className="united-page">
      <div className="united-content">
        <div className="united-text">
          <h1 className="united-title">United Airlines Mobile Redesign</h1>
          <p className="united-description">
            I've always enjoyed flying United Airlines, but I felt there was room for improvement in their mobile app experience. This prototype follows a user through the booking process from start to finish, focusing on improving the user experience with a cleaner interface and more intuitive navigation flow.
          </p>
        </div>
        <div className="united-image">
          <UnitedPlaceholder />
        </div>
      </div>
      
      {/* Comparison Section */}
      <div className="comparison-section">
        <h2 className="comparison-title">Consistent Layouts</h2>
        <p className="comparison-description">
        The existing United app shows inconsistencies in spacing, card styles, and layout. My redesign unifies these elements and focuses the experience on the company's goals of converting searches to bookings and building a loyal customer base with credit card rewards.
        </p>
        <div className="mockup-comparison booking-edge-to-edge">
          <div className="mockup-container">
            <div className="mockup-label">United</div>
            <div className="mockup-placeholder old-mockup">
              <img 
                src="/united-home-old.png" 
                alt="United Airlines App" 
                className="comparison-image"
              />
            </div>
          </div>
          <div className="mockup-container">
            <div className="mockup-label">Leo</div>
            <div className="mockup-placeholder new-mockup">
              <img 
                src="/united-home-new.png" 
                alt="Redesigned United App" 
                className="comparison-image"
              />
            </div>
          </div>
        </div>
      </div>
      
      {/* Second Comparison Section */}
      <div className="comparison-section">
        <h2 className="comparison-title">Decluttered Search</h2>
        <p className="comparison-description">
          Starting a search previously could be considered a daunting task; multiple pages and a litany of options made the process feel overwhelming. I aimed to make the search process as simple as possible with just the most important information. 
        </p>
        <div className="mockup-comparison booking-edge-to-edge">
          <div className="mockup-container">
            <div className="mockup-label">United</div>
            <div className="mockup-placeholder old-mockup">
              <img 
                src="/united-search-old.png" 
                alt="United Airlines App" 
                className="comparison-image"
              />
            </div>
          </div>
          <div className="mockup-container">
            <div className="mockup-label">Leo</div>
            <div className="mockup-placeholder new-mockup">
              <img 
                src="/united-search-new.png" 
                alt="Leo's Redesigned App" 
                className="comparison-image"
              />
            </div>
          </div>
        </div>
      </div>
      
      {/* Third Comparison Section */}
      <div className="comparison-section">
        <h2 className="comparison-title">Digestable Information</h2>
        <p className="comparison-description">
          On mobile, working with limited real estate sometimes means that less is more. I prioritized the most essential details like times and prices over extraneous details such as emission details. Moving the fare selection to a separate page lets users focus on their ideal flight first, then worry about the details later.
        </p>
        <div className="mockup-comparison booking-edge-to-edge">
          <div className="mockup-container">
            <div className="mockup-label">United</div>
            <div className="mockup-placeholder old-mockup">
              <img 
                src="/united-results-old.png" 
                alt="United Airlines Results" 
                className="comparison-image"
              />
            </div>
          </div>
          <div className="mockup-container">
            <div className="mockup-label">Leo</div>
            <div className="mockup-placeholder new-mockup">
              <img 
                src="/united-results-new.png" 
                alt="Leo's Results Design" 
                className="comparison-image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnitedPage;
